import { Stack } from '@mui/material';
import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

export default function ActivityIndicator() {
  return (
    <Stack
      flex={1}
      sx={{  width: '100%' , backgroundColor: 'transparent' }}
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress />
    </Stack>
  );
}
